import ValidityHelper from '../../../Helpers/ValidityHelper';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import TpRevenueByRevenuePeriodSearchParams from './TpRevenueByRevenuePeriodSearchParams';
import TpClientInvoiceService from '../../../Services/TpClientInvoiceService';

export default class TpRevenueByRevenuePeriodReportWindowDescription {
  static titleForCreate = 'TP Revenue by Revenue Period Report';
  static titleForEdit = 'TP Revenue by Revenue Period Report';
  static itemType = TpRevenueByRevenuePeriodSearchParams;
  static serviceFunction = TpClientInvoiceService.ExportTpRevenueToExcelAsync;
  static waitForServiceFunction = () => false;
  static finishButtonLabel = 'Export';
  static messageOnSuccess =
    'File creation has started and your report will be available in your personal download menu soon. You can continue to use the system while your request is being processed.';

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [
        {
          fieldName: 'RevenuePeriod',
          label: 'Revenue Period',
          className: 'col-12',
          type: InputTypesEnum.Number,
          validityChecker: ValidityHelper.forRequiredNumberFieldGreaterThanZero,
        },
        {
          fieldName: 'SelectedOffices',
          label: 'Offices',
          className: 'col-12',
          placeholder: 'select_all',
          type: InputTypesEnum.OfficeOrGroupForReportMultiSelect,
          validityChecker: ValidityHelper.forRequiredSelectField,
        },
      ],
    },
  ];
}
